import { FC } from 'react'
import { Typography } from '@mui/material'
import { ThemeButton } from 'ui/components/buttons'
import { UnknownIntegrationWrapper } from '../applicationSetup.styles'

interface Props {
  onBack: () => void
}

/* Reached by address with a slug the catalog does not carry, or one whose provider the portal has
 * no wording for. Either way there is nothing to set up here. */
const UnknownIntegration: FC<Props> = ({ onBack }) => (
  <UnknownIntegrationWrapper>
    <Typography className="unknown-title">This integration is not available</Typography>
    <Typography className="unknown-text">
      Onyxia has no setup for this integration. It may have been removed, or it is not enabled for your account.
    </Typography>
    <ThemeButton themevariant="secondary" onClick={onBack}>
      Back to Integrations
    </ThemeButton>
  </UnknownIntegrationWrapper>
)

export default UnknownIntegration
